/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * how are deliverables for this entity collected?
 */
export enum DeliverableCollectionStrategyEnum {
    ON_PLATFORM = 'ON_PLATFORM',
    OFF_PLATFORM = 'OFF_PLATFORM',
}
